import React from 'react';
import { MdDelete, MdEdit } from 'react-icons/md';
import Service from 'src/setup/network';
import { toastAlert } from 'src/utils/toastAlert';
import Button from '../button';
import Modal from '../modal';
import { useDispatch } from 'react-redux';

interface IProps {
  data: any;
  fetchData: any;
  url: string;
  children?: React.ReactNode;
}

const CrudIcon: React.FC<IProps> = ({ data, fetchData, url, children }) => {
  const [deleteContent, setDeleteContent] = React.useState<any>('');
  const [showDeleteModal, setShowDeleteModal] = React.useState(false);
  const [inputValue, setInputValue] = React.useState('');
  const handleDeleteModal = () => setShowDeleteModal(!showDeleteModal);
  const dispatch = useDispatch();

  const handleDelete = (value: any) => {
    setDeleteContent(value);
    handleDeleteModal();
  };

  const handleDeleteItems = async () => {
    // e?.preventDefault();
    // if (inputValue !== deleteContent.name) return;
    try {
      await Service.delete(`${url}/${deleteContent?.id}`);
      handleDeleteModal();
      toastAlert('success', `${deleteContent?.name} is successfully deleted`);
      // fetchData();
      dispatch(fetchData);
      setInputValue('');
    } catch (err: any) {
      handleDeleteModal();
      toastAlert('error', err?.response?.data?.message);
      setInputValue('');
    }
  };
  return (
    <>
      <div className="flex items-center space-x-4">
        {children}
        <div
          className="w-7 h-7 rounded-xl bg-light-grey bg-opacity-50 flex items-center justify-center"
          onClick={() => handleDelete(data)}
        >
          <MdDelete color="#E22B41" />
        </div>
      </div>

      {showDeleteModal && (
        <Modal
          isDelete={true}
          onClick={handleDeleteModal}
          title={
            <span>
              Are you sure want to delete?{' '}
              <span className="text-warning">{deleteContent?.name}</span>
            </span>
          }
        >
          {/* <div className="bg-border-color-dark p-5 mt-10 mb-3">
            <h4 className="text-xl  text-center">
              Please type this content to continue delete
              <span className="text-warning font-semibold mx-2">
                {deleteContent?.name}
              </span>
            </h4>
          </div> */}
          {/* <form action="" onSubmit={handleDeleteItems}>
            <input
              type="text"
              className="ring-1 ring-border-color-dark py-2.5 px-3 focus:outline-none w-full rounded shadow"
              value={inputValue}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                setInputValue(event?.target?.value)
              }
            />
            <div className="flex items-center justify-end">
              <Button
                text="delete"
                isValid={inputValue === deleteContent?.name}
                variant="primary"
                className="bg-warning px-8 mt-10"
                type="submit"
              />
            </div>
          </form> */}
          <div className="flex items-center justify-end">
            <Button
              text="delete"
              onClick={handleDeleteItems}
              // isValid={inputValue === deleteContent?.name}
              variant="primary"
              className="bg-warning px-8 mt-2"
              type="submit"
            />
          </div>
        </Modal>
      )}
    </>
  );
};

export default React.memo(CrudIcon);
